import { BRIEF_LIST_QUERY_KEY } from "@entities/brief/lib/constants";
import { ToastService } from "@shared/lib/services";
import { BackednResponse } from "@shared/lib/types";
import { IBriefRequest, IBriefResponse } from "@shared/lib/types/brief";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { BriefService } from "../services/brief.service";

export function useGetBriefs(params: IBriefRequest, enabled: boolean = true) {
  const { data, isLoading, isError, error, refetch } = useQuery<
    BackednResponse<IBriefResponse>
  >({
    queryKey: [...BRIEF_LIST_QUERY_KEY, params],
    queryFn: () => BriefService.getBriefs(params),
    enabled,
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    briefs: data?.data?.data || [],
    totaldata: data?.data?.pagination.totalCount || 0,
    isFetching: isLoading,
    isError,
    refetch,
  };
}
